import CloseIcon from "@mui/icons-material/Close"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Unstable_Grid2" // Grid version 2
import React from "react"

import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"

import { yupResolver } from "@hookform/resolvers/yup"
import { FormProvider, useForm } from "react-hook-form"
import * as yup from "yup"
import { toast } from "react-toastify"
import CustomTextField from "../CustomTextField"

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { es } from "date-fns/locale"
import { Controller } from "react-hook-form"

import WarningAmberIcon from "@mui/icons-material/WarningAmber"
import { DialogTitle, IconButton } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import { MuiFileInput } from "mui-file-input"
import { useContext } from "react"
import { useDispatch, useSelector } from "react-redux"
import { cargarAdjuntoSolicitud, solucitudActualizacionFamilia } from "../../Redux/solicitudes"
import { UserAuth } from "../../context/AuthContext"
import TokenContext from "../../context/TokenContext"
import CustomSearchSelect from "../CustomSearchSelect"
import { obtenerParentescos } from "../../Redux/autocompletados"
import { useEffect } from "react"
import { useState } from "react"
import CustomDateField from "../CustomDateField"

const opcionesGenero = [
  { value: "", label: "Seleccione una opción" },
  { value: "100000000", label: "Masculino" },
  { value: "100000001", label: "Femenino" },
  { value: "100000002", label: "otro" },
]

const opcionesTipoDocu = [
  { value: "", label: "Seleccione una opción" },
  { value: "100000000", label: "D.N.I" },
  { value: "100000001", label: "L.C" },
  { value: "100000002", label: "L.E" },
  { value: "100000003", label: "D.E" },
  { value: "100000004", label: "Pasaporte" },
]

const opcionesAcargo = [
  { value: "", label: "Seleccione una opción" },
  { value: "100000000", label: "Si" },
  { value: "100000001", label: "No" },
]

const ModalSolicitudFamilia = ({ open, handleClose }) => {
  const token = useContext(TokenContext)
  const dispatch = useDispatch()
  const theme = useTheme()
  const { empleado } = UserAuth()
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"))

  const estadoSolicitudFamilia = useSelector((store) => store.solicitudes.estadoSolicitudFamilia);

  const parentescosSelect = useSelector((store) => store.autocompletados.parentescos);

  const [selectedFiles, setSelectedFiles] = useState([])
  const [parentescos, setParentescos] = useState([])
 

  React.useEffect(() => {
    if (token) {
      dispatch(obtenerParentescos(token))
    }
  }, [token])

  useEffect(() => {
    if (parentescosSelect?.length > 0) {
      const parentescos = [];
      parentescosSelect.forEach((item) => {
        const object = {
          value: item.new_parentescoid,
          label: item.new_name,
        };
        parentescos.push(object);
      });
      setParentescos(parentescos);
    }
  }, [parentescosSelect]);

  const changeHandler = (newFile) => {
    setSelectedFiles(newFile)
  }

  const defaultValues = {
    empleado: empleado.empleadoid,
    asunto: null,
    fechaSolicitud: null,
    nroDocumento: null,
    tipoDocumento: null,
    apellidos: null,
    nombrePila: null,
    fechaNacimiento: null,
    genero: null,
    edad: null,
    parentesco: null,
    estaAcargo: null,
  }

  const validacionSchema = yup.object().shape({
    asunto: yup.string().required("Por favor indica el asunto."),
    fechaSolicitud: yup.string().required("Required"),
    tipoDocumento: yup.object({ value: yup.string().required("El tipo de documento es requerido") }),
    nroDocumento: yup.string().required("Por favor indica el nro de documento."),
    apellidos: yup.string().required("Por favor indica el/los apellido/s."),
  })

  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(validacionSchema),
    mode: "onChange",
    shouldFocusError: true,
  })

  const { handleSubmit, trigger, setValue } = methods

  const submitDatos = (datos) => {

    const formData = new FormData()
    for (let index = 0; index < selectedFiles.length; index++) {
      if (selectedFiles[index].size >= 15000000) {
        toast.error("El archivo no puede superar los 15 megas", {
          theme: "dark",
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        setSelectedFiles([])
        return
      }
      let element = selectedFiles[index]
      formData.append(`body${index}`, element)
    }

    dispatch(solucitudActualizacionFamilia(token, datos))
    .then((id) => {
      handleClose()
      if(selectedFiles.length > 0 && id.length > 0){
        dispatch(cargarAdjuntoSolicitud(token, formData, id, 'familiar_id'))
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  }

  return (
    <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
      <DialogTitle sx={{ justifyContent: "center", my: 1 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            p: 1,
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: "red",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <FormProvider {...methods}>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="asunto"
                label="Asunto"
                rules={{ required: "Required!" }}
                // helperText="Por favor indica el asunto."
                req={true}
                className="custom-helper"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mb: 2, mt: 2 }}>
              <CustomDateField
                name="fechaSolicitud"
                label="Fecha de solicitud:"
                rules={{ required: "Required!" }}
                helperText="Indica la fecha de solicitud"
                req={true}
                className="custom-helper"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect
                options={opcionesTipoDocu}
                req="true"
                type="text"
                name="tipoDocumento"
                lab="Tipo de documento"
                helperText="El tipo de documento es requerido"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                type="number"
                name="nroDocumento"
                label="N° de documento"
                rules={{ required: "Required!" }}
                // helperText="Por favor indica el nro de documento."
                req={true}
                className="custom-helper"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="apellidos"
                label="Apellidos"
                rules={{ required: "Required!" }}
                // helperText="Por favor indica el/los apellido/s."
                req={true}
                className="custom-helper"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField Component={TextField} name="nombrePila" label="Nombre de pila" />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mb: 2, mt: 2 }}>
              <CustomDateField
                name="fechaNacimiento"
                label="Fecha de nacimiento:"
                rules={{ required: "Required!" }}
                helperText="Indica la fecha de nacimiento"
                req={true}
                className="custom-helper"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect
                options={opcionesGenero}
                type="text"
                name="genero"
                lab="Genero"
                helperText="El tipo de documento es requerido"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField 
              Component={TextField} 
              name="edad" 
              label="Edad" 
              // helperText="Por favor indica la edad." 
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect
                options={parentescos}
                type="text"
                name="parentesco"
                lab="Parentesco"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect options={opcionesAcargo} type="text" name="estaAcargo" lab="¿Está a cargo?" />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 2 }}>
              <MuiFileInput value={selectedFiles} multiple label="Adjuntar documento" onChange={changeHandler} fullWidth />
            </Grid>
            <Grid sx={{ px: 2, mb: 2 }}>
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Box sx={{ height: "100%" }}>
                  <WarningAmberIcon color="warning" sx={{ mr: 1 }} />
                </Box>
                <Box sx={{ height: "100%" }}>
                  <Typography>El tamaño máximo permitido por archivo es de 15 MB</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                // sx={buttonSx}
                disabled={estadoSolicitudFamilia === "LOADING"}
                onClick={handleSubmit(submitDatos)}
              >
                Enviar
              </Button>
            </Grid>
          </FormProvider>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default ModalSolicitudFamilia
